import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningCircleIcon } from "@progress/kendo-svg-icons";

export default function NoDataPageTab(): ReactElement {
  const localizationService = useLocalization();


  return (
    <div className="gb-text-normal text-lg text-center mx-auto my-4 sm:my-8 px-4 py-6 sm:px-6 sm:py-10 w-full max-w-[550px]"
      style={{ borderRadius: '3px' }}>
      <div className="text-center mb-5">
        <SvgIcon icon={warningCircleIcon} style={{fontSize:'72px'}} size="xxxlarge"/>
      </div>
      <div>{`${localizationService.toLanguageString('custom.noDataFound', enMessages.custom.noDataFound)}`}</div>
      <br/>
      <div style={{textAlign:'left'}}>{`${localizationService.toLanguageString('custom.thisCouldBeBecause', enMessages.custom.thisCouldBeBecause)}`}:</div>
      <br />
      <ul style={{listStyleType: 'disc', textAlign:'left', display:'inline-block', listStylePosition:'inside'}}>
        <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em'}}>{`${localizationService.toLanguageString('custom.trySelectingDates', enMessages.custom.trySelectingDates)}`}</li>
        <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em'}}>{`${localizationService.toLanguageString('custom.unableTocommunicate', enMessages.custom.unableTocommunicate)}`}</li>
      </ul>
    </div>
  )}
